module.exports = __webpack_public_path__ + "fonts/Roboto-Black.05c437fb.eot";